const signaturePatternTags = (eventTag, eventAction, errorTag = {}, { customActionEvent, customCategoryEvent, customLabelTagResend } = {}) => ({
    inicio: {
        categoriaEvento: customCategoryEvent ?? "proc-otp",
        accionEvento: customActionEvent ?? "inicio",
        etiquetaEvento: eventTag ?? "start",
        amount: eventAction,
        action: "start",
        format: "otpAuthentication",
        component: "OTP/SMS",
        element: "backend"
    },
    error: {
        categoriaEvento:  customCategoryEvent ?? "proc-otp",
        accionEvento: customActionEvent ?? "error",
        etiquetaEvento: eventTag,
        amount: eventAction,
        ...(errorTag ? errorTag : {}),
    },
    exito: {
        categoriaEvento:  customCategoryEvent ?? "proc-otp",
        accionEvento: customActionEvent ?? "exito",
        etiquetaEvento: eventTag ?? "success",
        amount: eventAction,
        action: "success",
        format: "otpAuthentication",
        component: "OTP/SMS",
        element: "backend"
    },
    reinicio: {
        categoriaEvento: customCategoryEvent ?? "proc-otp",
        accionEvento: customActionEvent ? 'clickLink' : "reinicio",
        etiquetaEvento: customLabelTagResend ?? "restart",
        element: customLabelTagResend ? "requestNewCode" : null,
        format: "link",
        component: "OTP/SMS",
        action: "click",
        amount: eventAction
    }
});

module.exports = { signaturePatternTags };